export default __webpack_public_path__ + "static/omnichannel-43f1f794311105874388da744a3079f7.png";